module.exports = __webpack_public_path__ + "static/img/logo.9db1fc09.png";